export const setLanguage = 'setLanguage';
